// https://confluence.qe23.com/pages/viewpage.action?pageId=27855484
export default {
    "m9377": 14, // 第一事业部 9377手游平台
    "w9377": 11, // 第二事业部 9377页游平台
    "4366": 8, // 第三事业部 4366平台 平台事业部id代码写死为26
    "w4366": 8, // 第三事业部 4366平台 平台事业部id代码写死为26
    "mengw": 17, // 第四事业部 梦玩平台
    "chuangyue": 29, // 第五事业部 创悦平台
    "yuexin": 30, // 第六事业部 玥心平台
    "huanwan": 31, // 第七事业部 欢玩平台
}
